<script setup name="Template1">
import { ref, onMounted, onUnmounted } from "vue";
import ContainerCom from "./ContainerCom.vue";
import TextCom from "./TextCom.vue";
import ButtonCom from "./ButtonCom.vue";
// import productAPI from '../api/modules/product'
import { ElMessageBox } from "element-plus";

// 为模板组件定义属性
const props = defineProps({
  templateId: {
    type: String,
    default: "",
  },
});
// 处理删除事件
const handleDelete = (contentId) => {
  // emit删除事件
  emit("handleDelete", props.templateId);
};
// 定义emits
const emit = defineEmits(["edit", "handleDelete"]);

// 淡入动画相关状态和引用
const isVisible = ref(false);
const templateRef = ref(null);
let observer = null;

// 移动端检测逻辑
const isMobile = ref(false);
const checkIsMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};
// 处理交叉观察器回调
const handleIntersect = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // 使用setTimeout确保DOM更新后再执行
      setTimeout(() => {
        isVisible.value = true;
      }, 50);
      // 一旦可见，可以选择不再观察此元素
      // observer.unobserve(entry.target);
    }
  });
};

// 生命周期钩子
onMounted(() => {
  // 检测是否为移动端
  checkIsMobile();
  // 添加窗口大小变化监听
  window.addEventListener("resize", checkIsMobile);

  // 延迟创建观察器，确保元素已渲染
  setTimeout(() => {
    if (templateRef.value) {
      // 创建交叉观察器，保持持续观察
      observer = new IntersectionObserver(handleIntersect, {
        root: null,
        rootMargin: "0px",
        threshold: 0.1, // 当10%的元素可见时触发
      });

      // 开始观察元素
      observer.observe(templateRef.value);

      // 初始检查：如果元素已经在视窗内，立即触发动画
      const rect = templateRef.value.getBoundingClientRect();
      const isInViewport = rect.top < window.innerHeight && rect.bottom >= 0;
      if (isInViewport) {
        isVisible.value = true;
      }
    }
  }, 100);
});

onUnmounted(() => {
  if (observer && templateRef.value) {
    observer.unobserve(templateRef.value);
    observer.disconnect();
  }
  // 移除窗口大小变化监听
  window.removeEventListener("resize", checkIsMobile);
});
</script>

<!-- 添加组件描述注释 -->
<!-- 1号模板组件：包含一个containercom，内部含有三个textcom和一个buttoncom，所有组件都靠左对齐 -->

<template>
  <div class="template-1" ref="templateRef" :class="{ 'fade-in': isVisible }">
    <!-- PC端布局：ContainerCom包含TextCom -->
    <template v-if="!isMobile">
      <ContainerCom
        :allowFullScreenPlay="false"
        :contentId="props.templateId + '-container'"
        :showDelete="true"
        :showOrderNum="true"
        backgroundSize="cover"
        @order="emit('order', $event)"
        @delete="handleDelete"
      >
        <!-- 左侧布局容器 -->
        <div class="left-aligned-container">
          <!-- 三个TextCom组件 -->
          <TextCom :contentId="props.templateId + '-text-1'" />
          <TextCom class="text" :contentId="props.templateId + '-text-2'" />
          <TextCom :contentId="props.templateId + '-text-3'" />

          <!-- 一个ButtonCom组件 -->
          <ButtonCom
            style="margin-top: 40px"
            :contentId="props.templateId + '-button-1'"
          />
        </div>
      </ContainerCom>
    </template>

    <!-- 移动端布局：ContainerCom和TextCom分开 -->
    <template v-else>
      <!-- ContainerCom -->
      <!-- <div ></div> -->
      <div style="height: 40vw; width: 100%; background-color: #222">
        <ContainerCom
          :allowFullScreenPlay="false"
          :contentId="props.templateId + '-container'"
          :showDelete="true"
          backgroundSize="cover"
          @delete="handleDelete"
        >
        </ContainerCom>
      </div>

      <!-- TextCom组件放在ContainerCom下方 -->
      <div class="left-aligned-container mobile-text-container">
        <!-- 三个TextCom组件 -->
        <TextCom :contentId="props.templateId + '-text-1'" />
        <TextCom :contentId="props.templateId + '-text-2'" />
        <TextCom :contentId="props.templateId + '-text-3'" />

        <!-- 一个ButtonCom组件 -->
        <ButtonCom
          style="margin-top: 40px"
          :contentId="props.templateId + '-button-1'"
        />
      </div>
    </template>
  </div>
</template>

<style scoped>
.template-1 {
  height: 100vh;
  /* background-color: #222; */
  opacity: 0;
  /* transform: translateY(20px); */
  transition: opacity 1s ease-out, transform 1s ease-out;
}

/* 淡入动画类 */
.template-1.fade-in {
  opacity: 1;
  /* transform: translateY(0); */
}
/* 左侧布局样式 */
.left-aligned-container {
  position: absolute;
  left: 8.2292vw;
  /* max-width: 50vw; */
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
}

/* 为每个组件添加适当的间距 */
/* .left-aligned-container :deep(.base-com) {
  margin-bottom: 15px;
  width: fit-content;
} */

/* 确保容器样式正确 */
:deep(.content-area) {
  width: 100%;
}
.text {
  margin: 0vw 0 1vw;
}

/* 移动端适配样式 */
@media (max-width: 768px) {
  .template-1 {
    height: auto;
    /* min-height: 100vh; */
    /* background-color: #222; */
  }
  .left-aligned-container {
    position: static;
    transform: none;
    background: #222;
  }

  /* 移动端ContainerCom样式 */
  .mobile-container {
    height: 30vh;
    margin-bottom: 2rem;
  }

  /* 移动端文本容器样式 */
  .mobile-text-container {
    padding: 2rem;
    /* background-color: #222; */
    color: #fff;
  }

  /* 确保文本组件在移动端可见 */
  :deep(.mobile-text-container .base-com) {
    color: #fff;
  }

  /* 调整移动端文本组件间距 */
  .mobile-text-container :deep(.base-com) {
    margin-bottom: 15px;
  }
}
</style>
